import postTabularIntelView from './postTabularIntelComponent.html';
import VideoPlayer from '../../../videoPlayer/VideoPlayer.js';
import './postTabularIntelComponent.css';

export function postTabularIntelComponent() {
	return {
		bindings: {
			post: '=',
		},
		controllerAs: 'vm',
		controller: postTabularIntelComponentCtrl,
		template: postTabularIntelView,
	};
}

export class postTabularIntelComponentCtrl {
	constructor(modal, FineTunePosts, Post) {
		'ngInject';
		this.modal = modal;
		this.FineTunePosts = FineTunePosts;
		this.Post = Post;
	}

	isPreviewable() {
		return this.post.attachment_icon_classes && this.post.attachment_icon_classes.length > 0;
	}

	isVideo() {
		return !!VideoPlayer.getPlayableUrl(this.post);
	}

	getIconUrl() {
		let type = 'article';
		if (this.post.is_story) {
			type = 'bookmark';
		} else if (this.isVideo()) {
			type = 'video';
		} else if (this.isPreviewable()) {
			type = 'files';
		}
		return `/angular/assets/img/icons/${type}.svg`;
	}

	showDetails() {
		if (this.post.is_story) {
			window.location.href = post.source_link;
			return;
		}
		this.Post.viewFullscreen(this.post);
	}
}
